module.exports = __webpack_public_path__ + "img/feature1.f1bf1928.jpg";